<template>
  <div class="quiz-answer-sheet">
    <h6 class="text-center mb-4">
      <i class="icon-exam"></i> {{ score.quiz.title }}
    </h6>

    <quiz-paginator-line
      v-if="Object.keys(answers).length"
      :questions="questions"
      :answers="answers"
      :index="question_index"
      :score="score"
      @go-to="goTo"
    />

    <h5 class="page-title xsm  mb-4">
      {{ questions[question_index].title }}
    </h5>

    <template v-if="Object.keys(answers).length">
      <div
        v-for="a in questions[question_index].answer_options"
        :key="a.id"
        class="mb-3 mb-lg-4"
      >
        <form-radio
          :value="answers[questions[question_index].id].answer"
          :input-value="a.id"
          :label="a.title"
          :id="a.id"
          disabled
          :checked="a.is_right_answer"
          :customClass="getSheetClass(a, answers[questions[question_index].id])"
        />
      </div>
    </template>

    <div class="d-flex justify-content-end pt-5">
      <button
        v-if="question_index > 0"
        class="btn btn-outline-secondary px-4 mr-4"
        @click="previous"
      >
        <i class="icon-chevron-left mr-2"></i> Voltar
      </button>
      <button
        v-if="question_index < questions.length - 1"
        class="btn px-4 mr-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="next"
      >
        Próximo <i class="icon-chevron-right ml-2"></i>
      </button>
      <button
        v-if="question_index === questions.length - 1"
        class="btn px-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="$emit('close')"
      >
        Fechar
      </button>
    </div>
  </div>
</template>
<script>
import QuizPaginatorLine from "@/components/lesson/quiz/fragment/QuizPaginatorLine";

export default {
  components: { QuizPaginatorLine },
  props: {
    score: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      question_index: 0,
      answers: {}
    };
  },
  mounted() {
    this.prepareAnswers();
  },
  computed: {
    questions() {
      return [...this.score.quiz.questions].sort((a, b) => a.sort - b.sort);
    }
  },
  methods: {
    getSheetClass(a, answer) {
      if (this.score && this.score.quiz_answers.length) {
        return {
          wrong: a.id == answer?.answer && !a.is_right_answer,
          right: a.is_right_answer
        };
      }

      return {};
    },
    goTo(index) {
      this.question_index = index;
    },
    prepareAnswers() {
      // equalize index of question and answers to use in reduce
      const user_answers = this.score.quiz_answers.sort(
        (a, b) => a.question - b.question
      );
      const questions = this.score.quiz.questions.sort((a, b) => a.id - b.id);

      this.answers = questions.reduce((acc, curr, index) => {
        let answer = user_answers[index]
          ? user_answers[index].answer_option
          : "";

        return {
          ...acc,
          [curr.id]: { id: curr.id, answer }
        };
      }, {});
    },
    next() {
      const lastIndex = this.questions.length - 1;
      if (this.question_index + 1 <= lastIndex) {
        this.question_index += 1;
      }
    },
    previous() {
      if (this.question_index - 1 >= 0) {
        this.question_index -= 1;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.quiz-answer-sheet {
  .icon-close {
    position: absolute;
    top: 2%;
    right: 0%;
  }
}
</style>
